import React from "react";
import styled from "styled-components";
import { grey, lightGrey } from "../../Utils/styleConstants";
const StyledContainer = styled.div`
  padding: 1em;

  * {
    color: inherit;
  }
`;

const StyledTarifsContainer = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid #e1e1e1;
  border-radius: 5px;
  box-shadow: rgb(0 0 0 / 24%) 0 3px 8px;
  overflow: hidden;
`;

const TitleContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 1em 2em;
  background: #ececec;
  font-weight: bold;
  letter-spacing: 0.03em;
`;

const TarifContainer = styled.div`
  display: flex;
  letter-spacing: 0.03em;
  background-color: ${({ backgroundColor }) => backgroundColor || lightGrey};
  color: ${({ color }) => color || grey};
  font-size: ${({ fontSize }) => fontSize || "20px"};
  font-weight: bold;
  text-shadow: 0.5px 0 currentcolor;

  &:not(:last-child) {
    border-bottom: 1px solid #e1e1e1;
  }

  & > div {
    padding: 1.5em 2em;
  }
`;

const LabelContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.3em;
  width: ${({ labelWidth }) => labelWidth || "45%"};
  background: ${({ withColumnBackground }) =>
    withColumnBackground ? "#ececec" : "transparent"};
  border-right: ${({ withColumnBorder }) =>
    withColumnBorder ? "solid 0.25ex" : "none"};
`;

const PriceContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.3em;
  text-align: end;
  width: ${({ priceWidth }) => priceWidth || "55%"};
`;

const Label = styled.div`
  text-transform: uppercase;
  font-weight: ${({ normal }) => (normal ? "normal" : "bold")};
`;

const SubLabel = styled.div`
  font-size: 70%;
  font-weight: normal;
  text-shadow: none;
`;

const Price = styled.div`
  text-transform: uppercase;
  font-size: ${({ small }) => (small ? "70%" : "inherit")};
`;

const Devise = styled.span`
  color: ${({ color }) => color || "inherit"};
`;

const Value = styled.span`
  position: relative;
`;

const Unit = styled.span`
  font-size: 70%;
`;

const TarifRecapOption = ({
  title,
  rows = [],
  labelWidth = "45%",
  priceWidth = "55%",
  withColumnBackground = false,
  withColumnBorder = false,
}) => {

  return (
    <StyledContainer>
      <StyledTarifsContainer>
        {title && <TitleContainer>{title}</TitleContainer>}

        {rows.map((row, index) => (
          <TarifContainer
            key={index}
            backgroundColor={row.backgroundColor}
            color={row.color}
            fontSize={row.fontSize}
          >
            <LabelContainer
              labelWidth={labelWidth}
              withColumnBackground={withColumnBackground}
              withColumnBorder={withColumnBorder}
            >
              <Label normal={row.labelNormalWeight}>{row.label}</Label>

              {row.subLabels?.map((subLabel, subIndex) => (
                <SubLabel key={subIndex}>{subLabel}</SubLabel>
              ))}
            </LabelContainer>

            <PriceContainer priceWidth={priceWidth}>
              {row.prices?.map((price, priceIndex) => (
                <Price key={priceIndex} small={price.small}>
                  <Devise color={price.color}>
                    <Value>{price.value}</Value>
                    {price.showEuro !== false && price.value !== "inclus"
                      ? " €"
                      : ""}
                  </Devise>

                  {price.unit && price.value !== "inclus" && (
                    <Unit> {price.unit}</Unit>
                  )}
                </Price>
              ))}
            </PriceContainer>
          </TarifContainer>
        ))}
      </StyledTarifsContainer>
    </StyledContainer>
  );
};
export default TarifRecapOption;
